/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseMCPCallCompletedEvent = {
  type: "response.mcp_call.completed";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseMCPCallCompletedEvent$inboundSchema: z.ZodType<
  ResponseMCPCallCompletedEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.mcp_call.completed"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseMCPCallCompletedEvent$Outbound = {
  type: "response.mcp_call.completed";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseMCPCallCompletedEvent$outboundSchema: z.ZodType<
  ResponseMCPCallCompletedEvent$Outbound,
  z.ZodTypeDef,
  ResponseMCPCallCompletedEvent
> = z.object({
  type: z.literal("response.mcp_call.completed"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseMCPCallCompletedEventToJSON(
  responseMCPCallCompletedEvent: ResponseMCPCallCompletedEvent,
): string {
  return JSON.stringify(
    ResponseMCPCallCompletedEvent$outboundSchema.parse(
      responseMCPCallCompletedEvent,
    ),
  );
}
export function responseMCPCallCompletedEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseMCPCallCompletedEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseMCPCallCompletedEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseMCPCallCompletedEvent' from JSON`,
  );
}
